import { ref, onUnmounted } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

const ERROR_MAP = {
    102: 'Operación no permitida por tipo de tarjeta',
    105: 'Crédito insuficiente',
    108: 'Error en el número de tarjeta',
    109: 'Error en la fecha de caducidad',
    110: 'Error en los datos',
    111: 'Bloque CVC2 incorrecto',
    133: 'Error al procesar el pago, inténtelo de nuevo',
};

const MAX_POLL_ATTEMPTS = 30; 

export function usePagoPaycomet({ session_id, jet_id }, onCompletado) {
    const loading = ref(false);
    const iframe = ref('');
    const errorMsg = ref('');
    let pollInterval = null;
    let pollAttempts = 0;

    const stopPolling = () => {
        clearInterval(pollInterval);
        pollInterval = null;
        pollAttempts = 0;
    };

    const pollStatus = () => {
        pollAttempts++;

        if (pollAttempts > MAX_POLL_ATTEMPTS) {
            stopPolling();
            errorMsg.value = 'El pago tardó demasiado en confirmarse. Por favor, revisá tu email o contactá con soporte.';
            return;
        }

        store.dispatch(
            config.getVuexAlias('front.get-pedido-procesado-paycomet'),
            { filters: {}, session_id, tipo_pedido: 'cambio-nombre' }
        ).then(res => {
            if (!res.data.error) {
                stopPolling();
                onCompletado();
            } else if (res.data.message === 'Pedido fallido') {
                stopPolling();
                errorMsg.value = 'El pago ha fallado. Inténtalo de nuevo.';
            }
        }).catch(() => {
            if (pollAttempts >= MAX_POLL_ATTEMPTS) {
                stopPolling();
                errorMsg.value = 'No se pudo verificar el estado del pago. Por favor, revisá tu email o contactá con soporte.';
            }
        });
    };

    const procesarPago = async jetToken => {
        loading.value = true;
        errorMsg.value = '';

        try {
            const res = await store.dispatch(
                config.getVuexAlias('front.procesar-pago-paycomet'),
                { filters: {}, session_id, jetToken, tipo_venta: 'cambio-nombre' }
            );

            const response = res.data.response;

            if (response.challengeUrl) {
                iframe.value = response.challengeUrl;
                loading.value = false;
                pollAttempts = 0;
                pollInterval = setInterval(pollStatus, 3000);
            } else if (response.compraFinalizada) {
                loading.value = false;
                onCompletado();
            } else {
                loading.value = false;
            }
        } catch (error) {
            const code = error.response?.data?.response?.errorCode;
            errorMsg.value = ERROR_MAP[code] ?? 'Error al procesar el pago';
            loading.value = false;
        }
    };

    onUnmounted(() => {
        stopPolling();
    });

    return {
        loading,
        iframe,
        errorMsg,
        procesarPago,
    };
}